export default {
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  navbar: {
    changeLang: 'ChangeLang',
    screenfull: 'Screenfull',
    theme: 'Theme'
  },
  dropDownMenu: {
    personal: 'Personal',
    setting: 'Setting',
    modifyPassword: 'Modify Password',
    sign_out: 'Sign out'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  login: {
    system_login: 'System Login',
    username: 'Please enter user login name',
    phone: 'Please enter user phone number',
    loginName: 'Please enter user phone number or login name',
    password: ' Please enter your password',
    login: 'sign in'
  },
  errorCode: {
    '1000000': 'User name or password error',
    'default': 'System unknown error, please feedback to the administrator'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  button: {
    add: 'add',
    edit: 'edit',
    delete: 'delete',
    'batch-delete': 'batch delete',
    enable: 'enable',
    disable: 'disable',
    search: 'search',
    clear: 'clear',
    confirm: 'confirm',
    cancel: 'cancel'
  },
  column: {
    index: 'index',
    menuId: 'Menu ID',
    actionCode: 'action code',
    actionName: 'action name',
    status: 'status',
    menuName: 'menuName',
    url: 'url',
    remark: 'remark',
    operate: 'operate'
  },
  radio: {
    enable: 'enable',
    disable: 'disable'
  },
  tips: {
    tooltip: 'tooltip'
  },
  message: {
    selectOne: 'Please select a piece of data',
    selectOneOrMore: 'Please select one or more data'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js